import Select, { SelectProps } from 'antd/lib/select';
import { RESIDENTIAL_PROGRAM_TYPE } from 'src/domain/pjm/values';

export function ResidentialProgramTypeSelector(props: SelectProps) {
    const options = RESIDENTIAL_PROGRAM_TYPE.map(it => ({ label: it, value: it }));

    return (
        <Select
            showSearch
            autoClearSearchValue
            optionFilterProp="label" // to search by label not value
            placeholder="Select Type"
            options={options}
            {...props}
        />
    );
}
